<template>
  <div>
    <div id="errorPage"><h1>HTTP Status 401 ? Unauthorized</h1>
    <hr class="line">
    <p><b>Type</b> Status Report</p>
    <p><b>Description</b>
      The request has not been applied because it lacks valid authentication credentials for the target resource.</p>
    <hr class="line">
    <h3>Apache Tomcat/8.5.23</h3></div>
  </div>
</template>

<script>
export default {
  name: 'error',
};
</script>

<style scoped>h1 {
  font-family: Tahoma, Arial, sans-serif;
  color: white;
  background-color: #525D76;
  font-size: 22px;
}

h2 {
  font-family: Tahoma, Arial, sans-serif;
  color: white;
  background-color: #525D76;
  font-size: 16px;
}

h3 {
  font-family: Tahoma, Arial, sans-serif;
  color: white;
  background-color: #525D76;
  font-size: 14px;
}

#errorPage {
  font-family: Tahoma, Arial, sans-serif;
  color: black;
  background-color: white;
}

b {
  font-family: Tahoma, Arial, sans-serif;
  color: white;
  background-color: #525D76;
}

p {
  font-family: Tahoma, Arial, sans-serif;
  background: white;
  color: black;
  font-size: 12px;
}

a {
  color: black;
}

a.name {
  color: black;
}

.line {
  height: 1px;
  background-color: #525D76;
  border: none;
}
</style>




// WEBPACK FOOTER //
// src/components/Error.vue